import * as React from "react";
import * as _ from "lodash";
import { IPatientRedFlag } from "@curefit/ehr-common";
import IStaticDataValue from "../../../../../common/models/IStaticDataValue";
import ToggleButtonList from "../../ToggleButtonList";
import TextInput from "../../TextInput";
import {ChangeEvent} from "react";
import {AppPlaceholders} from "../../../utils/AppConstants";
import ModelFactory from "../../../models/ModelFactory";

/**
 * Created by aditya on 28/02/18.
 */


export interface PatientRedFlagsEditorProps {
    allRedFlags: IStaticDataValue[],
    selectedRedFlags: IPatientRedFlag,
    updateRedFlags: (updatedConcerns: Partial<IPatientRedFlag>) => void
}

class PatientRedFlagsEditor extends React.Component<PatientRedFlagsEditorProps> {

    constructor(props: PatientRedFlagsEditorProps) {
        super(props);
    }

    onSelectionChange = (updatedSelections: string[]) => {
        let staticRedFlags = this.props.allRedFlags;
        let troubles: IStaticDataValue[] = [];
        let updatedRedFlags = this.props.selectedRedFlags !== undefined ? this.props.selectedRedFlags : ModelFactory.createNewRedFlag();
        _.map(updatedSelections, (item) => {
            let selectedItem: IStaticDataValue;
            let displayValue = staticRedFlags.filter(redFlag => redFlag.internalValue === item)[0].displayValue;
            selectedItem = {
                internalValue: item,
                displayValue: displayValue
            }
            troubles.push(selectedItem);
        })
        updatedRedFlags.troubles = troubles;
        this.props.updateRedFlags(updatedRedFlags);
    }

    onCommentChange = (event: ChangeEvent<HTMLInputElement>) => {
        let updatedRedFlags = this.props.selectedRedFlags;
        updatedRedFlags.comment = event.target.value;
        this.props.updateRedFlags(updatedRedFlags);
    }

    getSelectionStringArray = (troubles: IStaticDataValue[]) => {
        return troubles !== undefined && troubles !== null ? troubles.map(item => item.internalValue) : [];
    }

    render() {
        let comment = !_.isEmpty(this.props.selectedRedFlags) && !_.isNull(this.props.selectedRedFlags) && this.props.selectedRedFlags.comment !==  null ? this.props.selectedRedFlags.comment : "";
        let troubles = !_.isEmpty(this.props.selectedRedFlags) && !_.isNull(this.props.selectedRedFlags) ? this.getSelectionStringArray(this.props.selectedRedFlags.troubles) : []
        return (
            <div className="patient-red-flags-editor">
                <ToggleButtonList listItems={this.props.allRedFlags} selectedItems={troubles} onSelectionChange={this.onSelectionChange}/>
                <div className={"red-flag-comments"}>
                    <TextInput name={"redFlag-comment"} value={comment} onChange={this.onCommentChange} placeholder={AppPlaceholders.RED_FLAGS_EDITVIEW_COMMENTS} />
                </div>
            </div>
        );
    }
}

export default PatientRedFlagsEditor